import { ReactElement } from 'react';
import styles from './CollectionView.module.scss';
import CollectionTable, { CollectionTableProps } from '../collection-table/CollectionTable';
import CollectionHeader from '../collection-header/CollectionHeader';
import { FilterProps } from '@casops/filters/types';

interface CollectionViewProps<T extends object> extends CollectionTableProps<T> {
  actions?: ReactElement | null;
  secondaryModelName?: string;
  filterProps?: FilterProps;
}

export const CollectionView = <T extends object>({
  sliceKey,
  modelName,
  secondaryModelName,
  rowData,
  defaultColDef,
  columnDefs,
  actions,
  hasData,
  noDataDescription,
  filterProps,
  onRowClick,
  rowClassRules,
  rowSelectMode,
  isRowSelectable,
  getRowId,
  showSummaryInTable = false,
  ensureNodeVisibleCallback,
  ensureNodeVisibleKey,
  includeHiddenColumnsInQuickFilter,
  apiResultLimit,
}: CollectionViewProps<T>): ReactElement => {
  return (
    <article className={styles.container}>
      <CollectionHeader
        sliceKey={sliceKey}
        modelName={modelName}
        secondaryModelName={secondaryModelName}
        actions={actions}
        filterProps={filterProps}
        countAll={rowData?.length}
        showSummary={!showSummaryInTable}
        apiResultLimit={apiResultLimit}
      />
      <CollectionTable<T>
        sliceKey={sliceKey}
        modelName={modelName}
        secondaryModelName={secondaryModelName}
        rowData={rowData}
        defaultColDef={defaultColDef}
        columnDefs={columnDefs}
        hasData={hasData}
        noDataDescription={noDataDescription}
        onRowClick={onRowClick}
        rowClassRules={rowClassRules}
        rowSelectMode={rowSelectMode}
        isRowSelectable={isRowSelectable}
        getRowId={getRowId}
        showSummaryInTable={showSummaryInTable}
        filterProps={filterProps}
        countAll={rowData?.length}
        ensureNodeVisibleCallback={ensureNodeVisibleCallback}
        ensureNodeVisibleKey={ensureNodeVisibleKey}
        includeHiddenColumnsInQuickFilter={includeHiddenColumnsInQuickFilter}
      />
    </article>
  );
};

export default CollectionView;
